/**
 * 邀请卡(邀约海报)相关业务逻辑
 */
import { useRoomBaseServer, useInviteServer, useUserServer } from 'middle-domain';
import tidCenter from '@/app-shared/utils/tidCenter.js';
import { getQueryString } from './tool';

/**
 * 获取邀请卡邀请码invite_code
 * 获取成功后，会把invite_code赋值给inviteServer.state.invite_code
 */
export async function fetchInviteCode() {
  const { watchInitData } = useRoomBaseServer().state;
  let inviteId; // 邀请人id
  let inviteIdType; // 邀请人id类型
  try {
    const webinarId = watchInitData.webinar.id;
    const subjectId = sessionStorage.getItem('subjectId');
    const tid = await tidCenter.getTid(webinarId, subjectId);
    if (tid) {
      if (tid.startsWith('visit_')) {
        inviteId = tid.substring(6);
        inviteIdType = 2; //游客
      } else {
        inviteId = tid;
        inviteIdType = 1;
      }
    } else {
      const token = sessionStorage.getItem('token');
      if (token) {
        // 邀请卡已登录
        inviteId = useUserServer().state.userInfo?.user_id;
        inviteIdType = 1;
      }
    }
  } catch {}
  if (!inviteId) {
    // 如果用户未登录，则取游客id
    inviteId = watchInitData.visitor_id;
    inviteIdType = 2;
  }
  const reqData = {
    source_id: watchInitData?.webinar?.id, // 数据来源id
    source_type: 1, // 数据来源id 类型 1.活动 2.落地页
    language_type: 0, // 语言类型  0.中文  1.英文 (活动下只有中文，固定语言类型写0)
    invite_id: inviteId, // 邀请人id
    channel: getQueryString('channel'), //channel
    invite_id_type: inviteIdType, // 邀请人id类型  1.C端用户id 2.游客id 3.B端用户
    business_uid: watchInitData?.webinar.userinfo.user_id, // b端用户id
    visitor_id: watchInitData?.visitor_id || ''
  };
  try {
    // 调用接口获取相关数据
    const res = await useInviteServer().getMyInviteCard(reqData);
    if (res && res.code === 200) {
      return res.data;
    }
    console.warn('获取邀请卡信息失败，res:', res);
    return null;
  } catch (error) {
    console.warn('获取邀请卡信息出现异常，error:', error);
    return null;
  }
}
